import { render, staticRenderFns } from "./ReportInvoiceCustomer.vue?vue&type=template&id=148f6163&scoped=true"
import script from "./ReportInvoiceCustomer.vue?vue&type=script&lang=js"
export * from "./ReportInvoiceCustomer.vue?vue&type=script&lang=js"
import style0 from "./ReportInvoiceCustomer.vue?vue&type=style&index=0&id=148f6163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f6163",
  null
  
)

export default component.exports